import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TramiteSuperfinancieraDto } from '../../../../dto/tramites/tramite-superfinanciera.dto';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { combineLatest } from 'rxjs';
import { PersonaDto } from '../../../../dto/tramites/persona.dto';
import { Constants } from '../../../../constants/constants';
import { TramiteDTO } from '../../models/tramiteDTO';
import { TramiteService } from '../../../../services/tramite.service';
import { PersonaLoginDTO } from '../../../../dto/util/persona.dto';

@Component({
  selector: 'app-sfc-notificaciones',
  templateUrl: './sfc-notificaciones.component.html',
  styleUrl: './sfc-notificaciones.component.scss'
})
export class SfcNotificacionesComponent implements OnInit, OnChanges {
  @Output() enviarTramite = new EventEmitter<{
    tramite: TramiteSuperfinancieraDto;
    event: Event;
  }>();

  @Output() guardarSinEnviarTramite = new EventEmitter<{
    tramite: TramiteSuperfinancieraDto;
    event: Event;
  }>();

  @Output() volver = new EventEmitter<number>();

  demandantesForm: FormGroup | null = null;
  demandadosForm: FormGroup | null = null;

  @Input() tramiteSfc?: TramiteSuperfinancieraDto;
  @Output() notificacionesEmit = new EventEmitter<{
    demandantes: FormArray;
    demandados: FormArray;
  }>();
  // Multilenguaje
  sfcText: any = {};
  comunText: any = {};
  alertaText: any = {};

  confirmacionEnvio: boolean = false;
  enviarCorreoDemandado: boolean = false;
  pesoTotalArchivosMB: string = '0.00';
  seleccionAceptoRechazoEnvio = false;

  dataUsuario!: PersonaLoginDTO;

  constructor(
    private fb: FormBuilder,
    private readonly translate: TranslateService,
    private readonly alertaModalService: AlertaModalService,
    private readonly tramiteService: TramiteService,
  ) {
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
  }

  ngOnInit() {
    this.demandantesForm = this.fb.group({
      demandantes: this.fb.array([]),
    });

    this.demandadosForm = this.fb.group({
      demandados: this.fb.array([]),
    });
    combineLatest([
      this.translate.stream('tramites'),
      this.translate.stream('comun-label'),
      this.translate.stream('alertas'),
    ]).subscribe(([tramitesText, comunLabelText, alertas]) => {

      this.sfcText = tramitesText;

      this.comunText = comunLabelText;

      this.alertaText = alertas;
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteSuperfinancieraDto =
      changes['tramiteSfc'].currentValue;
    if (this.demandadosForm?.valid && this.demandantesForm?.valid) {
      this.notificacionesEmit.emit({
        demandantes: this.demandantes,
        demandados: this.demandados,
      });
      this.consultarTramitePorID(this.tramiteSfc?.id ?? 0);
    }
  }

  consultarTramitePorID(id: number) {
    this.tramiteService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteDTO) => {
        if (resp) {
          this.tramiteSfc = {
            demandante: resp.demandante?.map((demandante: any) => ({
              ...demandante,
            })),
            demandado: resp.demandado?.map((demandado: any) => ({
              ...demandado,
            })),
          }
          // Limpiar si ya hay datos cargados
          this.demandantes.clear();
          this.demandados.clear();

          this.cargarDemandantes();
          this.cargarDemandados();
        }
      });
  }

  get demandantes(): FormArray {
    return this.demandantesForm?.get('demandantes') as FormArray;
  }

  get demandados(): FormArray {
    return this.demandadosForm?.get('demandados') as FormArray;
  }

  cargarDemandantes() {
    const listaDemandantes = this.tramiteSfc?.demandante;

    const identificadoresUnicos = new Set();

    listaDemandantes?.forEach(item => {
      const clave = `${item.idTipoIdentificacion}-${item.identificacion}`;

      if (!identificadoresUnicos.has(clave)) {
        identificadoresUnicos.add(clave);
        this.demandantes.push(this.creardemandantesForm(item));
      }
    });
  }


  cargarDemandados() {
    const listaDemandados = this.tramiteSfc?.demandado;

    if (listaDemandados?.length) {
      // Llenamos el array de formularios
      listaDemandados.forEach(item => {
        this.demandados.push(this.creardemandadosForm(item));
      });
    }
  }

  creardemandantesForm(item: PersonaDto): FormGroup {
    return this.fb.group({
      id: [item.id],
      correo: [
        item.correoElectronico,
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
      ],
      direccion: [
        item.direccionPersona
          ? item.direccionPersona[0].direccionNotificacion
          : null,
        [
          Validators.required,
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
      ],
    });
  }

  creardemandadosForm(item: PersonaDto): FormGroup {
    return this.fb.group({
      id: [item.id],
      primerNombre: [
        item.primerNombre,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
          // Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
      ],
      correo: [
        item.correoElectronico,
      ],
      direccion: [
        item.direccionPersona
          ? item.direccionPersona[0].direccionNotificacion
          : null,
      ],
    });
  }

  //TIPO1: ENVIAR SIN GUARDAR, TIPO2:ENVIAR
  continuar(e: Event, tipo: number) {

    if (this.demandantes.invalid) {
      this.demandantesForm?.markAllAsTouched();

      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );

      return;
    }

    if (this.demandados.invalid) {
      this.demandadosForm?.markAllAsTouched();

      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );

      return;
    }

    if (!this.confirmacionEnvio) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['ley_2213']
      );
      return;
    }

    if (!this.seleccionAceptoRechazoEnvio) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['envio_demanda']
      );
      return;
    }
    const demandantes: string[] = [];
    const demandados: string[] = [];

    const valoresDemandantes = this.demandantes.value;
    const valoresDemandados = this.demandados.value;

    for (const demandante of valoresDemandantes) {
      const item = `${demandante['id']};${demandante['direccion']};${demandante['correo']}`;
      demandantes.push(item);
    }

    for (const demandado of valoresDemandados) {
      const item = `${demandado['id']};${demandado['direccion']};${demandado['correo']}`;
      demandados.push(item);
    }

    const tramite: TramiteSuperfinancieraDto = {
      paso: 6,
      notificacionesDemandante: demandantes,
      notificacionesDemandado: demandados,
      id: this.tramiteSfc?.id,
      idTipoTramite: this.tramiteSfc?.idTipoTramite ?? Constants.TRAMITES.SUPER_FINANCIERA,
      usuario: {
        id: this.dataUsuario.idUsuario,
      },
      enviarCorreoDemandado: this.enviarCorreoDemandado,
    };

    this.enviar(e, tramite, tipo);
  }

  enviar(e: Event, tramite: TramiteSuperfinancieraDto, tipo: number) {
    if (tipo === 1) {
      this.guardarSinEnviarTramite.emit({ tramite: tramite, event: e });
    }
    if (tipo === 2) {
      this.enviarTramite.emit({ tramite: tramite, event: e });
    }
  }

  anterior() {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      paso--;
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(paso));
    }
    this.volver.emit(5);
  }
  get correoDemandado(): string {
    const correos = this.demandados.controls
      .map(control => control.get('correo')?.value)

    return correos!.length > 1
      ? `${correos!.slice(0, -1).join(', ')}, ${correos!.slice(-1)}`
      : `${correos![0]}`
  }

  get nombreDemandado(): string {
    const nombres = this.demandados.controls
      .map(control => control.get('primerNombre')?.value);

    return nombres!.length > 1
      ? `${nombres!.slice(0, -1).join(', ')}, ${nombres!.slice(-1)}`
      : `${nombres![0]}`;
  }

  rechazarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = false;
    this.alertaModalService.exito(
      this.comunText['accion-cancelada'],
      this.comunText['rechazo-envio']
    );
  }

  aceptarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = true;
    this.alertaModalService.exito(
      this.comunText['envio-confirmado'],
      this.comunText['acepta-copia']
    );
  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }
}
